/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Not_Found_DescInputs */

const en_err_not_found_desc = /** @type {(inputs: Err_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That link doesn't go anywhere. Head back home.`)
};

const id_err_not_found_desc = /** @type {(inputs: Err_Not_Found_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan itu tidak menuju ke mana pun. Balik ke beranda.`)
};

/**
* | output |
* | --- |
* | "That link doesn't go anywhere. Head back home." |
*
* @param {Err_Not_Found_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const err_not_found_desc = /** @type {((inputs?: Err_Not_Found_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_Found_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_err_not_found_desc(inputs)
	return en_err_not_found_desc(inputs)
});